import { ISSRPageData } from '@interfaces'
import { ObjectService } from '@services'
import { ObjectTemplate } from '@templates'
import { createNavLink } from '@utils'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

const ArtCollectionWorkDetailScreen = ({ pageData, global }: ISSRPageData) => {
  const { locale } = useRouter()
  const { t } = useTranslation()

  return (
    <ObjectTemplate
      global={global}
      pageData={pageData}
      headerLeftNavButtonLabel={t('nav:collections')}
      headerLeftNavButtonHref={createNavLink('collections', locale)}
    />
  )
}

export default ArtCollectionWorkDetailScreen

/**
 * slug is collection sourceId
 * object is object of collection sourceId
 */
interface ISSRProps {
  query: {
    object: string
  }
  locale: string
}

export async function getServerSideProps({ query, locale }: ISSRProps) {
  const { object } = query
  const pageData = {
    data: null,
    error: null,
  }

  try {
    const collection = await ObjectService.getObjectPureDetailPage(
      object,
      locale
    )

    pageData.data = collection
  } catch (err) {
    if (err instanceof Error) {
      pageData.error = { message: err.message }
    }
  }

  if (!pageData.data && !pageData.error) {
    pageData.error = { message: 'Object not found' }
  }

  return {
    props: { pageData, query },
  }
}
